import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP = "GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalUser/GetActiveExternalUserListForUserGroup`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP, service, mock);
